
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { getOptionList } from "@/api/api-dict";
import qrcodeShow from "@/components/qrcode/qrcode.vue";
import {
  getModelList,
  getDeviceOprAdd,
  getDeviceOprUpd,
  getDeviceOprDetail,
  getExpandPropertyList
} from "@/api/api-basic";
import { getOprStaList } from "@/api/api-operation-service";
import { getProtocolList } from "@/api/api-interconnection-service";
import safePasswordBox from "@/components/safe-password/safe-password";
import regular from "@/common/regular";
import i18n from "@/config/i18n";
import { State } from "vuex-class";
@Component({
  components: {
    qrcodeShow
  }
})
export default class PiEditPiles extends Vue {
  @State("sys") sys!: objAny;

  private defultUrl = this.$config.host + "/images/upload-img.png";
  private isAdd = true;
  private win: objAny = window;
  private deviceStatusList: objAny[] = [];
  private deviceTypeList: objAny[] = [];
  private deviceModelList: objAny[] = [];
  private staList: objAny[] = [];
  private protocolList: objAny[] = [];
  private protocolShow = false;
  private formInline: objAny = {
    staPkId: "",
    deviceType: "",
    deviceModelPkId: "",
    pilePkId: "",
    pileName: "",
    deviceStatus: "",
    protocolPkId: "",
    sn: "",
    internalNumber: "",
    extParamList: []
  };
  private isStaPkIdUp = false; //  是不是修改的时候没有站点
  private loading = false;
  private isDetails = false;
  private title = i18n.t("addPile.addName");
  private itemData: objAny = {};
  private formObj: objAny = {};
  private ruleInline: objAny = {
    staPkId: [
      {
        required: true,
        message: i18n.t("addPile.staNamePl"),
        trigger: "change"
      }
    ],
    deviceType: [
      {
        required: true,
        message: i18n.t("addPile.deviceTypePl"),
        trigger: "change"
      }
    ],
    deviceModelPkId: [
      {
        required: true,
        message: i18n.t("addPile.deviceModelPkIdPl"),
        trigger: "change"
      }
    ],
    sn: [
      {
        required: true,
        trigger: "blur",
        validator: (rule: objAny, value: string) => {
          // const reg = /^\d{8}$|^\d{12}$/;
          // const reg = /^\d+$/;
          const reg = /^[a-zA-Z\d]+$/;
          if (!value) {
            return new Error(i18n.t("addPile.snPl") + "");
          } else if (!reg.test(value)) {
            return new Error(i18n.t("addPile.snPl3") + "");
          }
          return true;
        }
      }
    ],
    internalNumber: [
      {
        required: true,
        trigger: "blur",
        validator: regular.int,
        max: 999
      }
    ],

    pileName: [
      {
        required: true,
        message: i18n.t("addPile.pileNamePl"),
        trigger: "blur",
        max: 15
      }
    ],

    deviceStatus: [
      {
        required: true,
        message: i18n.t("addPile.deviceStatusPl"),
        trigger: "change",
        max: 15
      }
    ],
    protocolPkId: [
      {
        required: true,
        message: i18n.t("addPile.protocolPkIdPl"),
        trigger: "change"
      }
    ]
  };

  private tableList: objAny[] = [];
  private tableColumns: objAny[] = [
    {
      title: i18n.t("commonTableName.gunPkId"),
      key: "gunPkId",
      minWidth: 140
    },
    {
      title: i18n.t("editGun.gunName"),
      key: "gunName",
      minWidth: 80
    },
    {
      title: i18n.t("addPile.qrcode"),
      key: "qrcode",
      slot: "qrcode",
      minWidth: 130
    },
    {
      title: i18n.t("editGun.manufacturerName"),
      key: "manufacturerName",
      slot: "manufacturerName",
      minWidth: 140
    },
    {
      title: i18n.t("editGun.parkNo"),
      key: "parkNo",
      minWidth: 80
    },
    {
      title: i18n.t("editGun.description"),
      key: "description",
      minWidth: 110
    }
  ];
  private qCodeUrl = "";
  private isShowQCode = false;

  async getDetail(): Promise<void> {
    const ret = await getDeviceOprDetail({
      pilePkId: this.formInline.pilePkId
    });
    if (ret.status === this.$config.apiStatus) {
      this.formInline = Object.assign(this.formInline, ret.data[0]);
      this.tableList = ret.data[0].chargeGunInfoVoList || [];
      this.formInline.deviceType = this.formInline.deviceType
        ? this.formInline.deviceType + ""
        : "";
      this.formInline.deviceStatus =
        this.formInline.deviceStatus >= 0
          ? this.formInline.deviceStatus + ""
          : "";
      if (this.formInline.staPkId == "" || !this.formInline.staPkId) {
        this.isStaPkIdUp = true;
      }
      this.formInline.sn = ret.data[0].serialNumber;
      console.log(this.formInline.deviceType);
      this.getModelListData();
      // this.formInline.protocolPkId = "1";
      // this.formInline.extParamList = [
      //   {
      //     propertyPkId: "1",
      //     propertyValue: "1"
      //   }
      // ];
      if (!this.formInline.extParamList) {
        this.formInline.extParamList = [];
      }
      if (
        this.formInline.extParamList &&
        this.formInline.extParamList.length > 0 &&
        !this.formInline.protocolPkId
      ) {
        this.formInline.protocolPkId = "1";
      }
      // if (this.formInline.protocolPkId == "1") {
      this.protocolChange(this.formInline.protocolPkId);
      // } else if (this.formInline.extParamList.length > 0) {
      //   this.protocolChange("1", "details");
      // }
      this.formInline.sn = ret.data[0].serialNumber;
    }
  }

  public handleSubmit(): void {
    this.formObj.validate((valid: boolean) => {
      if (valid) {
        if (this.isAdd) {
          this.addPile();
        } else {
          safePasswordBox({
            success: async (password: string) => {
              this.editPile(password);
            }
          });
        }
      }
    });
  }
  public getSubData(): objAny {
    const json = JSON.parse(JSON.stringify(this.formInline));
    // if (json.protocolPkId == "1") {
    const extParamList: objAny[] = [];
    json.extParamList.map((item: objAny) => {
      extParamList.push({
        propertyPkId: item.propertyPkId,
        propertyValue: item.propertyValue
      });
    });
    json.extParamList = extParamList.length > 0 ? extParamList : null;
    // } else {
    //   json.extParamList = null;
    // }
    return json;
  }
  async addPile(): Promise<void> {
    this.loading = true;
    const ret = await getDeviceOprAdd(this.getSubData());
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("addSuccess"));

      this.$common.goBack(this.$route, "/pile-manage/pile-list");
    }
    this.loading = false;
  }

  async editPile(password: string): Promise<void> {
    this.loading = true;
    const data: objAny = this.getSubData();
    data.password = password;
    const ret = await getDeviceOprUpd(data);
    if (ret.status === this.$config.apiStatus) {
      this.deviceModelList = ret.data;
      this.$Message.success(i18n.t("updateSuccess"));

      this.$common.goBack(this.$route, "/pile-manage/pile-list");
    }
    this.loading = false;
  }
  public handleReset(): void {
    this.formObj.resetFields();
  }

  async getModelListData(): Promise<void> {
    const ret = await getModelList({ deviceType: this.formInline.deviceType });
    if (ret.status === this.$config.apiStatus) {
      this.deviceModelList = ret.data;
    }
  }

  changeDeviceType(): void {
    if (this.formInline.deviceType) {
      this.getModelListData();
    }
  }

  async getStaList(): Promise<void> {
    const ret = await getOprStaList({ deviceType: this.formInline.deviceType });
    if (ret.status === this.$config.apiStatus) {
      this.staList = ret.data;
    }
  }
  async getProtocolList(): Promise<void> {
    const ret = await getProtocolList({
      protocolType: 0
    });
    if (ret.status === this.$config.apiStatus) {
      this.protocolList = ret.data;
    }
  }
  async getExpandPropertyList(protocolPkId: string): Promise<void> {
    const ret = await getExpandPropertyList({
      protocolPkId: protocolPkId
    });
    if (ret.status === this.$config.apiStatus) {
      const data: objAny[] = ret.data || [];

      if (data.length > 0) {
        this.protocolShow = true;
        const extParamList: objAny[] = [];
        const propertyDictPkIdList: string[] = [];
        data.map((item: objAny) => {
          propertyDictPkIdList.push(item.propertyDictPkId);
          const json: objAny = {
            propertyPkId: item.propertyPkId,
            propertyDictPkId: item.propertyDictPkId,
            propertyName: item.propertyName,
            propertyValue: ""
          };
          if (!this.isAdd || this.isDetails) {
            this.formInline.extParamList.map((formItem: objAny) => {
              if (formItem.propertyPkId == item.propertyPkId) {
                json.propertyValue = formItem.propertyValue;
              }
            });
          }
          extParamList.push(json);
        });

        getOptionList(propertyDictPkIdList).then(dataObj => {
          for (const i in dataObj) {
            extParamList.map((item: objAny) => {
              if (item.propertyDictPkId == i) {
                item.optionList = dataObj[i];
                if (dataObj[i][0] && item.propertyValue == "") {
                  item.propertyValue = dataObj[i][0].itemKey;
                }
              }
            });
          }
          this.formInline.extParamList = extParamList;
        });
      } else {
        this.protocolShow = false;
      }
    }
  }
  public protocolChange(val: string): void {
    // if (val == "1") {
    //   if (this.formInline.extParamList.length == 0 || type == "details") {
    this.getExpandPropertyList(val);
    //   }
    //   this.protocolShow = true;
    // } else {
    //   this.protocolShow = false;
    // }
  }
  public openQcode(url: string): void {
    this.isShowQCode = true;
    this.qCodeUrl = url;
  }
  created(): void {
    getOptionList(["12370", "102"]).then(res => {
      this.deviceStatusList = res["12370"];
      this.deviceTypeList = res["102"];
    });
  }

  mounted(): void {
    //如果路由有带电话参数，则取出来

    const itemData = this["$common"].get(this.$route.path);

    if (itemData) {
      if (this["$route"].path.indexOf("/pile-detail") != -1) {
        this.isDetails = true;
        this.title = i18n.t("addPile.detailsName");
      } else {
        this.title = i18n.t("addPile.updataName");
        this.isAdd = false;
        this.isDetails = false;
      }
      if (itemData.pilePkId != this.formInline.pilePkId) {
        for (const i in this.formInline) {
          if (
            typeof this.formInline[i] == "string" ||
            typeof this.formInline[i] == "number"
          ) {
            this.formInline[i] = "";
          } else if (Array.isArray(this.formInline[i])) {
            this.formInline[i] = [];
          }
        }
        // this.formInline = this["$common"].resetForm(this.formInline);
        this.formInline.pilePkId = itemData.pilePkId;
        this.formInline.staPkId = itemData.staPkId;
        this.getDetail();
      }
    } else {
      this.title = i18n.t("addPile.addName");
      this.isAdd = true;
      this.formInline.staPkId = this.$route.query.staPkId;
    }
    this.getStaList();
    this.$nextTick(() => {
      this.formObj = this.$refs["formInline"] || {};
    });
    this.getProtocolList();
  }
}
